import { render, staticRenderFns } from "./TableResponsive.vue?vue&type=template&id=7e45a988&scoped=true&"
import script from "./TableResponsive.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TableResponsive.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TableResponsive.vue?vue&type=style&index=0&id=7e45a988&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e45a988",
  null
  
)

export default component.exports